export default __webpack_public_path__ + "static/media/rmx-step.4335479c.png";